import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ValidatorFn } from '@angular/forms';

@Component({
	template: '',
})
export class BaseFieldComponent {
	@Output('onChange') public onChangeEmitter: EventEmitter<unknown> = new EventEmitter();
	@Output('onBlur') public onBlurEmitter: EventEmitter<unknown> = new EventEmitter();
	@Input('fg') public formGroup: FormGroup | undefined;
	@Input('formGroupOrControlName') public formGroupOrControlName: string = '';
	@Input('label') public label: string | undefined;
	@Input('placeholder') public placeholder: string | undefined;
	@Input('noLabel') public noLabel: boolean = false;

	/**
	 * This is meant to be overridden by an extending component.
	 * @date 7/15/2022 - 11:47:29 AM
	 *
	 * @public
	 * @static
	 * @type {ValidatorFn[]}
	 */
	public static validators: ValidatorFn[] = [];

	/**
	 * Send event up to listeners.
	 * @date 2/20/2024 - 12:38:21 PM
	 *
	 * @public
	 * @param {unknown} $event
	 */
	public onChange($event: unknown): void {
		this.onChangeEmitter.emit($event);
	}
}
